import React from 'react'
import {iconSize, itemStyle} from './styles'

const bgColor = '#eeeeee'

const styles = {
    icon: {
        borderRadius: '50%',
        height: iconSize.medium,
        lineHeight: iconSize.medium,
        width: iconSize.medium,
        background: bgColor
    },
    info: {
        marginLeft: '5px',
        backgroundColor: bgColor,
        width: '150px',
        height: '20px',
        borderRadius: '5px'
    }
}
const Placeholder = () => (
    <div data-testid="placeholder" className="papi-item" style={itemStyle}>
        <div className="icon" style={styles.icon} />
        <div className="info" style={styles.info} />
    </div>
)

export default Placeholder
